(() => {
  'use strict';

  // Open research disclosures before native fragment scrolling. Keep ordinary
  // hash navigation and browser history, including direct links and Back/Forward.
  const revealHashTarget = (hash, focus = false) => {
    if (!hash || hash === '#') return null;
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch { return null; }
    const target = document.getElementById(id);
    if (!target) return null;
    let opened = false;
    for (let ancestor = target.parentElement; ancestor; ancestor = ancestor.parentElement) {
      if (ancestor.tagName === 'DETAILS' && !ancestor.open) {
        ancestor.open = true;
        opened = true;
      }
    }
    if (focus) {
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
    return { target, opened };
  };
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      revealHashTarget(link.getAttribute('href'), true);
    });
  });
  const restoreHashTarget = () => {
    const result = revealHashTarget(location.hash, true);
    if (result?.opened) {
      requestAnimationFrame(() => result.target.scrollIntoView({ block: 'start', behavior: 'instant' }));
    }
  };
  window.addEventListener('hashchange', restoreHashTarget);
  restoreHashTarget();
  // Image/font loading can shift the footer after the deferred script first runs.
  if (location.hash) window.addEventListener('load', restoreHashTarget, { once: true });

  const animated = document.querySelector('[data-anim]');
  if (animated && 'IntersectionObserver' in window) {
    const reveal = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.remove('is-pre');
          reveal.unobserve(entry.target);
        }
      });
    }, { threshold: 0.35 });
    reveal.observe(animated);
  } else if (animated) {
    animated.classList.remove('is-pre');
  }

  const sticky = document.getElementById('sticky');
  const heroCTA = document.querySelector('.dhl-hero .dhl-cta');
  const offer = document.getElementById('nabidka');
  if (!sticky || !heroCTA || !offer) return;
  const mobile = window.matchMedia('(max-width: 959px)');
  let menuOpen = false;
  const updateSticky = () => {
    const heroBox = heroCTA.getBoundingClientRect();
    const offerBox = offer.getBoundingClientRect();
    const offerVisible = offerBox.top < window.innerHeight && offerBox.bottom > 0;
    const visible = mobile.matches && !menuOpen && heroBox.bottom < 0 && !offerVisible;
    sticky.classList.toggle('on', visible);
    sticky.setAttribute('aria-hidden', String(!visible));
    sticky.inert = !visible;
    sticky.querySelector('a').tabIndex = visible ? 0 : -1;
  };
  let queued = false;
  window.addEventListener('scroll', () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { updateSticky(); queued = false; });
  }, { passive: true });
  window.addEventListener('resize', updateSticky);
  document.addEventListener('dashea:menu-toggle', event => {
    menuOpen = Boolean(event.detail.open);
    updateSticky();
  });
  updateSticky();
})();
